export { default as AiChatPage } from './AiChatPage';

export const moduleConfig = {
  module: {
    title: 'AI Chat',
    description: 'Chat with the AI assistant and review conversation history.',
  },
};
